<template>
  <div class='ProdutoView'>
    <div class="cont-item">
      <div class="block-left">
        <div class="cont-imgs">
          <carousel
          v-if="ItemSelected01.img.length"
          v-model="currentSlide"
          :items-to-show="1"
          >
            <slide v-for="(img, key) in ItemSelected01.img.map(i => api + i.img)" :key="key">
              <vue-image-zoomer
              :regular="img"
              hover-message="⚲ Zoom"
              img-width="300"
              img-height="300"
              />
            </slide>
            <template #addons>
              <navigation />
            </template>
          </carousel>
          <div class="cont-icon-img" v-if="!ItemSelected01.img.length">
            <img-icon
            :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
            />
          </div>
          <div class="cont-nav">
            <Carousel
            v-if="ItemSelected01.img.length"
            id="thumbnails"
            :items-to-show="ItemSelected01.img.length"
            :wrap-around="true"
            v-model="currentSlide"
            ref="carousel"
            >
              <Slide v-for="(img, key) in ItemSelected01.img.map(i => api + i.img)" :key="key">
                <div @click="slideTo(key)">
                  <img class="img-pagination" :src="img"> 
                </div>
              </Slide>
            </Carousel>
          </div>
        </div>
      </div>
      <div class="block-right">
        <div class="name">
          {{ ItemSelected01.name }}
        </div>
        <div class="price">
          <div class="disablePrice">R$ {{ ItemSelected01.oferta }}</div>
          <div>R$ {{ ItemSelected01.preco }}</div>
        </div>
        <div class="desc">
          {{ ItemSelected01.descricao }}
        </div>
        <prod-caracter/>
        <div class="btn">
          <btn-whats @click="sendMessageWhats(ItemSelected01)"/>
        </div>
        <btn-like :data="ItemSelected01"/>
      </div>
    </div>
    <enb-suggestion/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css'
import BtnWhats from './BtnWhats'
import ProdCaracter from './ProdCaracter'
import EnbSuggestion from './EnbSuggestion'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import BtnLike from '@/components/Theme01/Like/BtnLike'
import api from '@/mixins/api'
export default {
  name: 'ProdutoView',
  components: { VueImageZoomer, Carousel, Slide, Navigation, BtnWhats, ProdCaracter, EnbSuggestion, ImgIcon, BtnLike },
  computed: {
    ...mapGetters(['ItemSelected01'])
  },
  mixins: [api],
  data () {
    return {
      currentSlide: 0,
      qtda: 1
    }
  },
  methods: {
    ...mapActions(['sendMessageWhats', 'GetProductId']),
    slideTo(val) {
      this.currentSlide = val
    }
  },
  async beforeMount () {
    if(typeof this.$route.params.link !== 'undefined') {
      await this.GetProductId(this.$route.params.link)
    }
  }
}
</script>

<style scoped>
.ProdutoView {
  width: 100%;
}

.cont-item {
  width: 70%;
  display: flex;
  margin: auto;
}

.cont-icon-img {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-left {
  width: 40%;
  padding-top: 2%;
}

.block-right {
  width: 40%;
  padding-top: 2%;
}

.cont-nav {
  width: 50%;
  margin: auto;
}

.img-pagination {
  width: 50px;
  height: 50px;
}

.name {
  font-size: 20px;
  color: orange;
  text-align: left;
}

.price {
  display: flex;
  font-size: 20px;
  text-align: left;
  padding-top: 2%;
}

.disablePrice {
  text-decoration: line-through;
  color: #CCCCCC;
  padding-right: 2%;
}

.desc {
  font-size: 16px;
  text-align: left;
  padding-top: 2%;
}

.btn {
  display: flex;
  justify-content: left;
  padding-top: 3%;
}

@media (max-width: 500px) {
  .cont-item {
    display: block;
  }
  .block-left {
    width: 100%;
  }
  .block-right {
    width: 100%;
  }
  .name {
    text-align: center;
  }
  .desc {
    text-align: center;
  }
  .price {
    width: 100%;
    justify-content: center;
  }
  .btn {
    justify-content: center;
  }
}
</style>
